import { TaxItemsResponse } from '@business/entities/tax';
import { R } from '@core/utils/r';
import { InvoiceSalesTaxData } from '@modules/common/InvoiceSalesTax';
import { ProposalDiscountFormData } from '@modules/proposal/ProposalBuilderPage/Components/ProposalProductsOverlay';

export function totalTaxAmt(items: TaxItemsResponse[], discount: ProposalDiscountFormData, salesTax: InvoiceSalesTaxData, newWay = true) {
  if (!salesTax.isSalesTax) return 0;
  const taxSubTotal = taxableSubTotal(items, discount, newWay);
  if (salesTax.isSalesTax) {
    if (salesTax.taxAmount && salesTax.taxAmount > 0 && !newWay) {
      return salesTax.taxAmount;
    }
    return R.round((salesTax.value * taxSubTotal) / 100, 2);
  }
  return 0;
}

export function totalItemsTax(items: TaxItemsResponse[]) {
  const taxSubtotal = R.sum(
    items
      .filter(t => t.taxable)
      .map(item => {
        if (R.isNaN(item.subtotal)) {
          return 0;
        }
        return item.subtotal;
      }),
  );
  return R.isNaN(taxSubtotal) ? 0 : taxSubtotal;
}

export function subTotal(items: TaxItemsResponse[]) {
  return R.sum(items.map(item => item.subtotal));
}

export function taxableSubTotal(items: TaxItemsResponse[], discount: ProposalDiscountFormData, newWay: boolean) {
  if (newWay) {
    return totalItemsTax(items) - getTaxDiscount(items, discount);
  } else {
    return totalItemsTax(items);
  }
}

export function getTaxDiscount(items: TaxItemsResponse[], discount: ProposalDiscountFormData) {
  const taxSubTotal = totalItemsTax(items);
  if (!discount.isDiscount) return 0;
  if (allItemsTaxable(items)) {
    if (discount.type === 'fixed') {
      return discount.value;
    } else {
      return R.round((discount.value * taxSubTotal) / 100, 2);
    }
  } else {
    if (discount.type === 'fixed') {
      const disPercent = (discount.value * 100) / subTotal(items);
      return R.round((disPercent * taxSubTotal) / 100, 2);
    } else {
      return R.round((discount.value * taxSubTotal) / 100, 2);
    }
  }
}

export function allItemsTaxable(items: TaxItemsResponse[]) {
  return items.filter(item => item.taxable).length === items.length;
}
